export const cloudsKeys = {
    all: ['clouds'] as const,
    lists: () => [...cloudsKeys.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...cloudsKeys.lists(), { filters }] as const,
    details: () => [...cloudsKeys.all, 'detail'] as const,
    detail: (id: string) => [...cloudsKeys.details(), id] as const,
} as const;

export const regionKeys = {
    all: ['regions'] as const,
    lists: () => [...regionKeys.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...regionKeys.lists(), { filters }] as const,
    details: () => [...regionKeys.all, 'detail'] as const,
    detail: (id: string) => [...regionKeys.details(), id] as const,
} as const;
